

















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Mixin
 ---------------------------------------- */

import BlockMixin from '@mixin/blocks';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    mixins: [
        BlockMixin
    ],

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class SectionBlock extends Vue {}

